/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Col_PriorityInputs */

const en_tasks_col_priority = /** @type {(inputs: Tasks_Col_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const pt_br2_tasks_col_priority = /** @type {(inputs: Tasks_Col_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioridade`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Tasks_Col_PriorityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_priority = /** @type {((inputs?: Tasks_Col_PriorityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_PriorityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_priority(inputs)
	return pt_br2_tasks_col_priority(inputs)
});